import { Button, Flex } from "@chakra-ui/react";

interface ActionCellProps {
  hasChanged: boolean;
  onClickSaveDocument: (documentId: string) => void;
  documentId: string;
}

export function ActionCell({
  hasChanged,
  onClickSaveDocument,
  documentId,
}: ActionCellProps) {
  return (
    <Flex justifyContent={"flex-end"} alignItems="center">
      <Button
        disabled={!hasChanged}
        padding="10px 20px"
        border={"2px solid #2F80FD"}
        borderRadius="100px"
        fontSize="14px"
        lineHeight="24px"
        fontWeight="400"
        color="#2F80FD"
        bg="#FFF"
        onClick={(e) => onClickSaveDocument(documentId)}
      >
        Save Changes
      </Button>
    </Flex>
  );
}
